import axios from 'axios';
import * as actions from './actionsTypes';
import * as actionsEmployees from '../employees/actionsTypes';
import messages from '../messages';
import GestorDocumentalServices from './gestorDocumental.services';
import {downloadDocument} from '../../components/gestorDocumental/GestorDocumental';
import toastr from 'toastr';
import config from '../../config';

export const getDocs = (filters, setDocs) => async dispatch => {
  try {
    dispatch({
      type: actions.LOADER_GESTOR_DOCUMENTAL_DATA,
      payload: true
    });
    const resp = await GestorDocumentalServices.getDocuments(filters);
    setDocs(resp.data.data);
    /*dispatch({
      type: actions.GET_GESTOR_DOCUMENTAL_DATA,
      payload: resp.data.data
    });*/
    dispatch({
      type: actions.GESTOR_DOCUMENTAL_ERROR_GET_DATA,
      payload: ''
    });
    dispatch({
      type: actions.GESTOR_DOCUMENTAL_FORM_SEND_DATA_ERROR,
      payload: ''
    });
  } catch (ex) {
    let message = '';
    if (axios.isAxiosError(ex)){
      if(ex.response?.data){
        message = ex.response.data.message;
      }else{
        message = ex.message === 'Network Error' ? messages.networkError : ex.message;  
      }
    }else{
      message = ex.message === 'Network Error' ? messages.networkError : ex.message; 
    }
    dispatch({
      type: actions.GESTOR_DOCUMENTAL_ERROR_GET_DATA,
      payload: message
    });
  }finally{
    dispatch({
      type: actions.LOADER_GESTOR_DOCUMENTAL_DATA,
      payload: false
    });
  }
}

export const viewDoc = (filters, fileName, contentTypeGD, setLoader) => async (dispatch, getState) => {
  try {
    /*dispatch({
      type: actions.LOADER_VIEW_DOCUMENT,
      payload: true
    });*/
    setLoader(true);
    const {doc} = getState().gestorDocumental;
    let data = {};
    if(doc && doc.id === filters.id) {
      data = doc;
    }else{
      const resp = await GestorDocumentalServices.viewDocument(filters);
      data = resp.data;
      if(data.length === 0 || data[0].error){
        dispatch({
          type: actions.VIEW_DOC_ERROR,
          payload: data.length === 0 ? 'No se pudo encontrar el archivo' : data[0].error
        });    
      }else{
        dispatch({
          type: actions.VIEW_DOC,
          payload: resp.data
        });
        dispatch({
          type: actions.VIEW_DOC_ERROR,
          payload: ''
        });
      }
    }
    if(data.length > 0 && !data[0].error){
      downloadDocument(`${contentTypeGD}${data[0].imagen}`, fileName);
    }
    // let eseeDocs = window.open(aName[0]);
    // eseeDocs.document.write(`<iframe  width='100%' height='100%' src='${filebase64}' frameborder></iframe>`);
  } catch (ex) {
    let message = '';
    if (axios.isAxiosError(ex)){
      if(ex.response?.data){
        message = ex.response.data.Message;
      }else{
        message = ex.message === 'Network Error' ? messages.networkError : ex.message;  
      }
    }else{
      message = ex.message === 'Network Error' ? messages.networkError : ex.message; 
    }
    dispatch({
      type: actions.VIEW_DOC_ERROR,
      payload: message
    });
  }finally{
    setLoader(false);
    /*dispatch({
      type: actions.LOADER_VIEW_DOCUMENT,
      payload: false
    });*/
  }
}

export const getAreas = () => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.LOADER_GESTOR_DOCUMENTAL_AREAS,
      payload: true
    });
    // const { areas } = getState().gestorDocumental;
    // console.log(areas)
    // if(areas.length === 0) {
      const resp = await GestorDocumentalServices.getAreas();
      if(resp.data[0].error){
        dispatch({
          type: actions.GESTOR_DOCUMENTAL_AREAS_ERROR,
          payload: resp.data[0].error
        });
      }else{
        dispatch({
          type: actions.GET_GESTOR_DOCUMENTAL_AREAS,
          payload: resp.data
        });
        dispatch({
          type: actions.GESTOR_DOCUMENTAL_AREAS_ERROR,
          payload: ''
        });
      }
    // }
  } catch (ex) {
    let message = '';
    if (axios.isAxiosError(ex)){
      if(ex.response?.data){
        message = ex.response.data.message;
      }else{
        message = ex.message === 'Network Error' ? messages.networkError : ex.message;  
      }
    }else{
      message = ex.message === 'Network Error' ? messages.networkError : ex.message; 
    }
    dispatch({
      type: actions.GESTOR_DOCUMENTAL_AREAS_ERROR,
      payload: message
    });
  }finally{
    dispatch({
      type: actions.LOADER_GESTOR_DOCUMENTAL_AREAS,
      payload: false
    });
  }
}

export const getCarpetas = (idarea = null) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.LOADER_GESTOR_DOCUMENTAL_CARPETAS,
      payload: true
    });
    // const { carpetas } = getState().gestorDocumental;
    // if(carpetas.length === 0) {
      let respAreas = null;
      if(!idarea){
        respAreas = await GestorDocumentalServices.getAreas();
      }
      const resp = await GestorDocumentalServices.getCarpetas(idarea ? idarea : respAreas.data[0].id);

      if(resp.data[0].error){
        dispatch({
          type: actions.GESTOR_DOCUMENTAL_CARPETAS_ERROR,
          payload: resp.data[0].error
        });
      }else{
        dispatch({
          type: actions.GET_GESTOR_DOCUMENTAL_CARPETAS,
          payload: resp.data
        });
        dispatch({
          type: actions.GESTOR_DOCUMENTAL_CARPETAS_ERROR,
          payload: ''
        });
      }
    // }
  } catch (ex) {
    let message = '';
    if (axios.isAxiosError(ex)){
      if(ex.response?.data){
        message = ex.response.data.message;
      }else{
        message = ex.message === 'Network Error' ? messages.networkError : ex.message;  
      }
    }else{
      message = ex.message === 'Network Error' ? messages.networkError : ex.message; 
    }
    dispatch({
      type: actions.GESTOR_DOCUMENTAL_CARPETAS_ERROR,
      payload: message
    });
  }finally{
    dispatch({
      type: actions.LOADER_GESTOR_DOCUMENTAL_CARPETAS,
      payload: false
    });
  }
}

export const saveDoc = (data, options) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.LOADER_GESTOR_DOCUMENTAL_FORM_SEND_DATA,
      payload: true
    });
    //const {} = getState().
    debugger;
    const resp = await GestorDocumentalServices.saveDocument(data);
    if(options.docType){
      const { employee } = getState().employees;
      switch (options.docType) {
        case 'estado_civil':
          employee.estado_civil_archivo = [resp.data.resultado];
          break;
        case 'direccion':
          employee.croquis = [resp.data.resultado];
          break;
        default:
          break;
      }
      dispatch({
        type: actionsEmployees.GET_EMPLOYEE,
        payload: employee
      });
    }else{
      options.docsState.setDocs([...options.docsState.docs, resp.data.resultado]);
      ///const resp = await GestorDocumentalServices.getDocuments(filters);
      // const { docs } = getState().gestorDocumental;
      // dispatch({
      //   type: actions.GET_GESTOR_DOCUMENTAL_DATA,
      //   payload: [...docs, resp.data.resultado]
      // });
    }

    dispatch({
      type: actions.GESTOR_DOCUMENTAL_FORM_SEND_DATA_ERROR,
      payload: ''
    });
    toastr.success(messages.successMessage, '', {
      progressBar: true,
      rtl: true,
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)){
      if(ex.response?.status){
        switch (ex.response.status) {
          case 400:
            message = ex.response.data.mensaje ? ex.response.data.mensaje : ex.response.data.resultado ? ex.response.data.resultado[0].response : messages.errorMessage;
            break;
          case 500:
            message = messages.errorMessage + ex.response.statusText
            break;
          default:
            message = ex.response.data.mensaje ? ex.response.data.mensaje : ex.response.data.resultado ? ex.response.data.resultado[0].response : messages.errorMessage;
            break;
        }
      }else{
        message = ex.message === 'Network Error' ? messages.networkError : ex.message;  
      }
    }else{
      message = ex.message === 'Network Error' ? messages.networkError : ex.message; 
    }
    dispatch({
      type: actions.GESTOR_DOCUMENTAL_FORM_SEND_DATA_ERROR,
      payload: message
    });
  }finally{
    dispatch({
      type: actions.LOADER_GESTOR_DOCUMENTAL_FORM_SEND_DATA,
      payload: false
    });
  }
}

export const editDoc = (data, id, ind, options ) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.LOADER_GESTOR_DOCUMENTAL_FORM_SEND_DATA,
      payload: true
    });
    debugger;
    const resp = await GestorDocumentalServices.editDocument(id, data);
    if(options.docType){
      const { employee } = getState().employees;
      switch (options.docType) {
        case 'estado_civil':
          employee.estado_civil_archivo = [resp.data];
          break;
        case 'direccion':
          employee.croquis = [resp.data];
          break;
        default:
          break;
      }
      dispatch({
        type: actionsEmployees.GET_EMPLOYEE,
        payload: employee
      });
    }else{
      ///const resp = await GestorDocumentalServices.getDocuments(filters);
      /*const { docs } = getState().gestorDocumental;
      dispatch({
        type: actions.GET_GESTOR_DOCUMENTAL_DATA,
        payload: [...docs, resp.data.resultado]
      });*/
      let docs = options.docsState.docs.slice();
      docs[ind] = resp.data;
      options.docsState.setDocs(docs);
      // const { docs } = getState().gestorDocumental;
      // docs[ind] = resp.data;
      // dispatch({
      //   type: actions.GET_GESTOR_DOCUMENTAL_DATA,
      //   payload: docs
      // });
    }
    dispatch({
      type: actions.GESTOR_DOCUMENTAL_FORM_SEND_DATA_ERROR,
      payload: ''
    });
    toastr.success(messages.successMessage, '', {
      progressBar: true,
      rtl: true,
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)){
      if(ex.response?.status){
        switch (ex.response.status) {
          case 400:
            message = ex.response.data.mensaje ? ex.response.data.mensaje : ex.response.data.resultado ? ex.response.data.resultado[0].response : messages.errorMessage;
            break;
          case 500:
            message = messages.errorMessage + ex.response.statusText
            break;
          default:
            message = ex.response.data.mensaje ? ex.response.data.mensaje : ex.response.data.resultado ? ex.response.data.resultado[0].response : messages.errorMessage;
            break;
        }
      }else{
        message = ex.message === 'Network Error' ? messages.networkError : ex.message;  
      }
    }else{
      message = ex.message === 'Network Error' ? messages.networkError : ex.message; 
    }
    dispatch({
      type: actions.GESTOR_DOCUMENTAL_FORM_SEND_DATA_ERROR,
      payload: message
    });
  }finally{
    dispatch({
      type: actions.LOADER_GESTOR_DOCUMENTAL_FORM_SEND_DATA,
      payload: false
    });
  }
}

export const getSubNiveles = (filter) => async dispatch => {
  try {
    dispatch({
      type: actions.LOADER_SUBNIVELES,
      payload: true
    });
    const { subNiveles }             = config.gestorDocumental;
    const respSubNiveles             = await GestorDocumentalServices.getSubNiveles(filter);
    const {data}                     = respSubNiveles;
    const oTipoDoc                   = data.find(item => item.descripcion.toLowerCase() === subNiveles[0].toLowerCase());
    const oDescripcion               = data.find(item => item.descripcion.toLowerCase() === subNiveles[1].toLowerCase());
    if (!oTipoDoc && !oDescripcion){
      throw new Error('Error al obtener los subniveles tipo de documento y descripción');
    }
    //* Tipo de documento
    filter.cdid                      = oTipoDoc.id;
    const respSubNivelListTipoDocumento      = await GestorDocumentalServices.getSubNivelList(filter);
    //* Descripción
    filter.cdid                      = oDescripcion.id;
    const respSubNivelListDescripcion        = await GestorDocumentalServices.getSubNivelList(filter);

    dispatch({
      type: actions.GET_SUBNIVELES,
      payload: {
        subNivelTipoDocList: respSubNivelListTipoDocumento.data,
        subNivelDescripcionList: respSubNivelListDescripcion.data 
      }
    });
    dispatch({
      type: actions.GET_SUBNIVELES_ERROR,
      payload: ''
    });
  } catch (ex) {
    let message = '';
    if (axios.isAxiosError(ex)){
      if(ex.response?.data){
        message = ex.response.data.message;
      }else{
        message = ex.message === 'Network Error' ? messages.networkError : ex.message;  
      }
    }else{
      message = messages.errorMessage + ', detalle: ' + ex.message; 
    }
    dispatch({
      type: actions.GET_SUBNIVELES_ERROR,
      payload: message
    });
  }finally{
    dispatch({
      type: actions.LOADER_SUBNIVELES,
      payload: false
    });
  }
}

export const getSubNivelesSancionesDocs = (filter) => async dispatch => {
  try {
    dispatch({
      type: actions.LOADER_SUBNIVELES,
      payload: true
    });
    const { subNiveles }             = config.gestorDocumental;
    const respSubNiveles             = await GestorDocumentalServices.getSubNiveles(filter);
    const {data}                     = respSubNiveles;
    const oModulo                    = data.find(item => item.descripcion.toLowerCase() === subNiveles[2].toLowerCase());
    const oFiles                     = data.find(item => item.descripcion.toLowerCase() === subNiveles[3].toLowerCase());
    if (!oModulo && !oFiles){
      throw new Error('Error al obtener los subniveles tipo de documento y descripción');
    }
    //* Medidas disciplinarias
    filter.cdid                     = oModulo.id;
    const respSubNivelModule        = await GestorDocumentalServices.getSubNivelList(filter);
    filter.cdid                     = oFiles.id;
    const respSubNivelFiles         = await GestorDocumentalServices.getSubNivelList(filter);

    dispatch({
      type: actions.GET_SUBNIVELES,
      payload: {
        module: respSubNivelModule.data,
        files: respSubNivelFiles.data
      }
    });
    dispatch({
      type: actions.GET_SUBNIVELES_ERROR,
      payload: ''
    });
  } catch (ex) {
    let message = '';
    if (axios.isAxiosError(ex)){
      if(ex.response?.data){
        message = ex.response.data.message;
      }else{
        message = ex.message === 'Network Error' ? messages.networkError : ex.message;  
      }
    }else{
      message = messages.errorMessage + ', detalle: ' + ex.message; 
    }
    dispatch({
      type: actions.GET_SUBNIVELES_ERROR,
      payload: message
    });
  }finally{
    dispatch({
      type: actions.LOADER_SUBNIVELES,
      payload: false
    });
  }
}